(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    // Keep the button price in sync when a different variant is selected
  document.addEventListener('variant:update', (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const scope = event.target?.closest?.('.shopify-section') || document;

    scope.querySelectorAll('[data-add-to-cart-price]').forEach((priceEl) => {
      const id = priceEl.getAttribute('data-add-to-cart-price');
      const newPriceEl = html.querySelector(`[data-add-to-cart-price="${id}"]`);

      if (newPriceEl) {
        priceEl.innerHTML = newPriceEl.innerHTML;
        priceEl.hidden = newPriceEl.hidden;
      } else {
        priceEl.hidden = true;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
